<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">Metas</h1>
      <div class="row">
        <div class="col-xs-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Listagem de Metas"
            report-title="Metas"
            api-url="meta/list"
            :fields="fields"
            :initial-page="pagina"
            :pageCollection="'metas'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="custom-font" for="MET_DCTITULO_filter"
                    >Título</label
                  >
                  <input
                    type="text"
                    v-model="MET_DCTITULO"
                    class="form-control"
                    name="MET_DCTITULO_filter"
                  />
                </div>
                <div class="col-sm-6">
                  <label class="custom-font" for="MET_DLOBJETIVO_filter"
                    >Objetivo</label
                  >
                  <input
                    type="text"
                    v-model="MET_DLOBJETIVO"
                    class="form-control"
                    name="MET_DLOBJETIVO_filter"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'admin_metas_save' }"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon> Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-primary"
                  @click="editar(props.rowData)"
                >
                  <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                </button>
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
            <template slot="icon" slot-scope="props">
              <img
                :src="concateImgPathWith(props.rowData.MET_DLURLIMAGEM)"
                :alt="props.rowData.MET_DCTITULO"
                width="48"
                height="48"
              />
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'
import modal from '@/components/common/Modal'

export default {
  name: 'metas',
  inject: ["showConfirm"],
  data() {
    return {
      fields: [
        {
          name: '__slot:icon',
          title: 'Logo',
          dataClass: 'align-middle'
        },
        {
          name: 'MET_DCTITULO',
          sortField: 'MET_DCTITULO',
          title: 'Título',
          dataClass: 'align-middle',
          filterable: false
        },
        {
          name: 'MET_DLOBJETIVO',
          sortField: 'MET_DLOBJETIVO',
          title: 'Objetivo',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'MET_NRNUMERO',
          sortField: 'MET_NRNUMERO',
          title: 'Número',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list,
    modal
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  methods: {
    editar(data) {
      this.$router.push({
        name: 'admin_metas_save',
        params: { MET_IDMETA: data.MET_IDMETA }
      })
    },
    excluir(data) {
      var dt = this.$refs.vuetable
      data.type = 'META'

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
          .post('meta/delete', data)
          .then(() => dt.refresh())
          .catch(e => {
            console.log(e + ' | Houve um error ao tentar excluir esta meta, por favor tente novamente mais tarde.')
          })
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    },
    concateImgPathWith(fileImage) {
      return this.$root.$data.imgUrl + fileImage + '?' + new Date().getTime()
    },
    consultar() {
      this.$refs.vuetable.refresh()
    },
    limpar() {
      this.MET_DCTITULO = ''
      this.MET_DLOBJETIVO = ''
      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'metas',
        value: 1
      })
    }
  },
  computed: {
    filtros() {
      const { MET_DCTITULO, MET_DLOBJETIVO } = this
      return {
        MET_DCTITULO,
        MET_DLOBJETIVO
      }
    },
    pagina: {
      get() {
        const { metas } = this.$store.state.vuetableState
        const { pagina } = metas
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'metas',
          value: value
        })
      }
    },
    MET_DCTITULO: {
      get() {
        const { metas } = this.$store.state.vuetableState
        const { MET_DCTITULO } = metas.filtros

        return MET_DCTITULO
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'MET_DCTITULO',
          collection: 'metas',
          value: value
        })
        this.resetPageStore()
      }
    },
    MET_DLOBJETIVO: {
      get() {
        const { metas } = this.$store.state.vuetableState
        const { MET_DLOBJETIVO } = metas.filtros

        return MET_DLOBJETIVO
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'MET_DLOBJETIVO',
          collection: 'metas',
          value: value
        })
        this.resetPageStore()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/metas/index.vue